import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

import { Typography, Grid, Button } from '@mui/material';

export default function LoginPage() {
  const navigate = useNavigate();
  const handleClicks = () => {
    navigate('/login', { replace: true });
  };

  return (
    <>
      <Helmet>
        <title> User Activated | SMARTSHIELD </title>
      </Helmet>

      {}

      <Grid
        xs={12}
        item
        md={6}
        style={{
          backgroundImage: 'url(/assets/Signup.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'absolute',
          height: '100vh',
          zIndex: '1',
        }}
      >
        {''}
        <div className="relative z-100 container mx-auto px-4 h-full">
          <div className="relative flex content-center items-center justify-center h-full">
            <div className="w-full lg:w-4/12 px-4">
              <div
                className="relative flex flex-col items-center min-w-0 break-words w-full mb-6 shadow-2xl shadow-blue-500/50 rounded-lg bg-blueGray-200 border-0"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 1)', // You can adjust the background color and opacity here
                }}
              >
                <div className="relative rounded-t mb-0 px-6 py-6">
                  <img src="/assets/smartshield.webp" alt="SMARTSHIELD Logo" className="w-140" width="140" height="140" />
                  <div className="text-center mb-3">
                    <h4 className="text-blueGray-500 text-xl font-bold">Welcome!</h4>
                  </div>
                  <hr className="mt-6 border-b-1 border-blueGray-300" />
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0 flex flex-col items-center">
                  <div className="flex auto items-center text-center text-blue-400">
                    <small>Your account has been created successfully, Please log in to complete the process.</small>
                  </div>
                  <Button className="mt-4 shadow-blue-500/50" onClick={handleClicks}>
                    Login
                  </Button>
                </div>
                <Typography variant="body2" align="center" style={{ color: '#12A2CE' }}>
                  {' '}
                  &copy; 2024 ChainSmart - All Rights Reserved
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </Grid>
    </>
  );
}
